import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKheopsLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22.9255 8.22015C26.8656 6.2874 29.5731 6.43704 30.9207 7.46918L31.0466 7.57172C31.7066 8.143 32.0691 8.87248 32.1189 9.7514L32.1248 9.92914C32.135 11.2205 31.4796 12.8045 30.4021 14.4575C29.353 16.0668 28.0426 17.5329 27.0535 18.5424C26.2604 19.3506 26.2599 20.6503 27.0515 21.4594V21.4604C28.0393 22.4705 29.3492 23.9369 30.3982 25.5463C31.4755 27.1991 32.1309 28.7818 32.1208 30.0707C32.1129 30.97 31.7907 31.7204 31.1697 32.3129L31.0408 32.4291C30.4386 32.9495 29.5568 33.2797 28.325 33.2797C26.8828 33.2797 25.0476 32.8191 22.9333 31.7846H22.9343C20.4533 30.5674 17.9519 28.7088 16.0798 26.5727C14.3061 24.5488 13.2229 22.4253 13.0662 20.4731L13.0476 20.0854V19.9975C13.0492 17.9346 14.1393 15.6477 16.0339 13.4711C17.7911 11.4525 20.1141 9.6791 22.4558 8.45746L22.9246 8.22015H22.9255Z",
		stroke: "#201B13",
		strokeWidth: 3.25
	}), /* @__PURE__ */ _jsx("path", {
		opacity: .5,
		d: "M13.965 6.62506C15.1892 6.62506 16.6643 7.49831 17.9406 9.93268L18.1935 10.4405C19.3703 12.9362 20.0558 16.3252 20.0558 20.0001C20.0558 23.6708 19.3702 27.064 18.1935 29.5596C16.8626 32.3814 15.2708 33.3751 13.965 33.3751C12.741 33.3748 11.2663 32.5019 9.99036 30.0684L9.73743 29.5596C8.56065 27.064 7.87512 23.6708 7.87512 20.0001C7.87512 16.5584 8.47746 13.3607 9.52258 10.918L9.73743 10.4405L9.7384 10.4395C11.0683 7.61575 12.6585 6.6253 13.965 6.62506Z",
		stroke: "#201B13",
		strokeWidth: 3.25
	})]
});
export default SvgKheopsLogoIcon;
